import { Colors } from '@constants/colors.constants';
import { Close } from '@icons/index';
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack, Typography } from '@mui/material';

interface ModalComponentProps {
  actions?: JSX.Element | JSX.Element[];
  'aria-label'?: string;
  content?: JSX.Element | JSX.Element[];
  handleClose?: () => void;
  fullWidth?: boolean;
  fullScreen?: boolean;
  contentFullWidth?: boolean;
  contentHeight?: string;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
  scroll?: 'body' | 'paper';
  title?: string;
  subTitle?: string;
  customColor?: string;
  zIndex?: number;
}

const ModalComponent = (props: ModalComponentProps) => {
  const {
    actions,
    content,
    fullWidth,
    fullScreen,
    contentFullWidth,
    handleClose,
    contentHeight,
    maxWidth = 'md',
    scroll = 'paper',
    title,
    subTitle,
    customColor
  } = props;

  return (
    <Dialog open={true} maxWidth={maxWidth} fullScreen={fullScreen ? true : false} fullWidth={fullWidth === undefined ? true : fullWidth}
      scroll={scroll} onClose={handleClose} aria-label={props['aria-label']} PaperProps={{ style: { backgroundColor: customColor } }}>
      {(title || handleClose) && (
        <DialogTitle>
          <IconButton aria-label="close" onClick={handleClose}>
            <Close />
          </IconButton>
          <Stack>
            {title}
            <Typography fontSize={12} fontWeight="400" color={Colors.textWithOpacity}>{subTitle}</Typography>
          </Stack>
        </DialogTitle>
      )}
      {!!content && <DialogContent sx={{ height: contentHeight, padding: fullScreen || contentFullWidth ? 0 : 'inerte' }}>{content}</DialogContent>}
      {!!actions && <DialogActions>{actions}</DialogActions>}
    </Dialog >
  );
};

export default ModalComponent;
